import memoize from 'transmute/memoize';
import { SnowflakeGaugeMigration } from './migrations/snowflakeGauge';
import { SnowflakeSlicedMigration } from './migrations/snowflakeSliced';
import { ConfigSlicedMigration } from './migrations/configSliced';
// Array<Migration> ensures all imported migrations implement the Migration interface
const availableMigrations = [SnowflakeGaugeMigration, SnowflakeSlicedMigration, ConfigSlicedMigration];
const findMigrationForReport = (report, gates) => {
  var _availableMigrations$;
  if (!report) {
    return undefined;
  }
  return (_availableMigrations$ = availableMigrations.find(migration => migration.canMigrate(report, gates))) === null || _availableMigrations$ === void 0 ? void 0 : _availableMigrations$.migrate;
};
export const getMigratedReport = memoize((report, gates) => {
  const maybeMigrationFunction = findMigrationForReport(report, gates);
  return maybeMigrationFunction && report ? maybeMigrationFunction(report, gates) : undefined;
});